var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-index-v"},[_c('div',{staticClass:"inf-wrapper"},[_c('div',{staticClass:"auto-height"},[_c('div',{staticClass:"content calc-line",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }